const system = {
  loading: "جارٍ التحقق من عزل بيانات التطبيق لكل مستخدم…",
  unavailable: {
    title: "حالة النظام غير متاحة",
    retry: "إعادة المحاولة",
    fetchFailed: "تعذر جلب حالة النظام.",
    healthFailed: "فشل فحص حالة النظام.",
  },
  header: {
    title: "بنية النظام وحالته",
    description: "هذه الصفحة تخص النظام بالكامل ومتاحة للمشرف العام فقط. تتحقق من أن كل سجل في التطبيق — بما في ذلك المصادر والفلاتر وتفضيلات الذكاء الاصطناعي والمنشورات المراقبة وحالة صندوق المحتوى والوجهات — مملوك لعضو واحد. تبقى بيانات الاعتماد مُدارة من مساحة «وجهاتي» الخاصة بكل عضو.",
    scope: "نطاق إدارة النظام",
    notice: "تنبيه حالة النظام",
    cutoverTitle: "الانتقال إلى الملكية الكاملة لبيانات التطبيق ما زال معلقًا",
    cutoverDescription: "لا يزال يلزم إصدار منسق لقاعدة البيانات والخادم قبل أن يصبح وجود مالك شرطًا بنيويًا لكل مصدر وفلتر وإعداد ذكاء اصطناعي ومنشور مراقب وعنصر Inbox ووجهة.",
    supabaseEndpoint: "نقطة اتصال Supabase:",
    notConfigured: "غير مُعد",
    refresh: "تحديث الحالة",
  },
  overview: {
    backendLabel: "تشغيل الخادم",
    backendTitle: "PostgreSQL مُطبّع",
    backendActive: "الخادم نشط",
    backendUnavailable: "الخادم غير متاح",
    architectureLabel: "بنية متعددة المستخدمين",
    architectureTitle: "عزل مساحات العمل",
    isolated: "البيانات الشخصية معزولة",
    cutoverIncomplete: "الانتقال غير مكتمل",
    automationLabel: "الأتمتة",
    automationTitle: "الجمع والتنظيف",
    jobsActive: "المهام نشطة",
    automationIncomplete: "الأتمتة غير مكتملة",
    securityLabel: "أمان البيانات",
    securityTitle: "جداول مملوكة للخادم",
    protected: "{{protected}}/{{expected}} محمية",
  },
  monitoring: {
    title: "بيانات المراقبة الشخصية",
    description: "تُخزن المصادر ومنشورات تيليجرام المجمعة بشكل منفصل لكل عضو، حتى إذا راقب عضوان القناة العامة نفسها.",
    sourceChannels: "قنوات المصدر",
    monitoredPosts: "المنشورات المراقبة · 24 ساعة",
  },
  workspace: {
    title: "بيانات مساحة العمل الشخصية",
    description: "يتم أيضًا فصل سير عمل Inbox وإعدادات النشر حسب مالك مساحة العمل. الأرقام أدناه مؤشرات مجمعة لحالة النظام فقط.",
    destinationTargets: "وجهات النشر",
    inboxRows: "صفوف سير عمل Inbox",
    publishedWorkflow: "حالات النشر",
    supabaseMembers: "أعضاء Supabase",
    legacyMembers: "الأعضاء القدامى",
    unownedRows: "صفوف التطبيق بلا مالك",
    publishStates: "حالات نشر لكل مستخدم",
    durableIdentities: "هويات دائمة نشطة",
    usernameOwned: "مساحات مملوكة باسم المستخدم",
    shouldRemainZero: "يجب أن يبقى 0",
    owners_zero: "لا يوجد مالكون",
    owners_one: "مالك واحد",
    owners_two: "مالكان",
    owners_few: "{{formattedCount}} مالكين",
    owners_many: "{{formattedCount}} مالكًا",
    owners_other: "{{formattedCount}} مالك",
  },
  runtime: {
    title: "حدود بيانات التشغيل",
    description: "كل جداول التطبيق شخصية. سجل التوافق القديم فقط هو سجل على مستوى النظام، ولا يحصل عملاء المتصفح على صلاحية كتابة مباشرة في قاعدة البيانات.",
    scopes: { personal: "شخصي", compatibility: "توافق" },
    tables: {
      source_channels: "المصادر الشخصية",
      filters: "الفلاتر الشخصية",
      destination_targets: "الوجهات الشخصية",
      ai_settings: "إعدادات الذكاء الاصطناعي الشخصية",
      posts: "المنشورات المراقبة الشخصية",
      user_inbox_items: "حالة Inbox الشخصية",
      curator_settings: "التوافق القديم",
    },
  },
  isolation: {
    title: "فحوصات عزل مساحة العمل",
    description: "تتحقق هذه الفحوصات من عدم وجود بيانات تطبيق خارج مساحة عمل أحد الأعضاء.",
    ownershipTitle: "الملكية الكاملة لبيانات التطبيق",
    ownershipDescription: "يجب أن يكون للمصادر والفلاتر وإعدادات الذكاء الاصطناعي والمنشورات والوجهات مالك.",
    inboxTitle: "عزل Content Inbox",
    inboxDescription: "ترتبط حالة المراجعة/التحرير/النشر فقط بالمنشورات المملوكة للعضو نفسه.",
    orphanTitle: "فحص بيانات التطبيق بلا مالك",
    orphanDescription: "يجب أن يكون لكل صف إنتاج في التطبيق مالك.",
    ready: "جاهز",
    missing: "مفقود",
    cutoverPending: "الانتقال معلق",
    noOrphans: "لا توجد صفوف بلا مالك",
    unowned: "{{count}} بلا مالك",
    note: "تعريفات المصادر والفلاتر وتفضيلات الذكاء الاصطناعي ونصوص المنشورات المراقبة والحالات والسجل والأخطاء لا تُعامل أبدًا كإعدادات عامة. تبقى بيانات اعتماد بوتات تيليجرام في أسرار Vault الخاصة بالمستخدم.",
  },
  automation: {
    title: "أتمتة الجمع",
    description: "يحدد المجدول المالكين الذين لديهم مصادر مفعلة ويشغّل الجمع داخل كل مساحة عمل معزولة باستخدام فلاتر ذلك العضو وسجلات منشوراته.",
    cronInstalled: "pg_cron مثبت",
    cronMissing: "pg_cron غير موجود",
    netInstalled: "pg_net مثبت",
    netMissing: "pg_net غير موجود",
    empty: "لم يتم العثور على مهام جمع TGReposter.",
    jobs: { import: "استيراد Source Inbox", cleanup: "تنظيف Inbox المتجدد" },
    schedules: { everyFiveMinutes: "كل 5 دقائق", everyHour: "كل ساعة" },
    succeeded: "نجح",
    active: "نشط",
    lastRunFailed: "فشل آخر تشغيل",
    disabled: "معطل",
    lastRun: "آخر تشغيل: {{time}}",
    noRun: "لم يُسجل أي تشغيل",
  },
  security: {
    title: "تشغيل تديره الهجرات وآمن افتراضيًا",
    description: "تُدار التغييرات البنيوية بإصدارات عبر هجرات Supabase. كل إعدادات التطبيق ومحتواه مملوكة للأعضاء، وتُنفذ عمليات الكتابة الحساسة عبر مسارات خادم موثقة بدلًا من الوصول المباشر إلى قاعدة البيانات من المتصفح.",
  },
} as const;

export default system;
